import { WEBHOOK_SELECTION, DATASET_SELECTION } from 'automation-ui-enrollment/types';
const LIST_PATH_NAME = 'actions/enrollment/filters';
const EVENT_PATH_NANE = 'triggers/event';
const SCHEDULED_PATH_NAME = 'triggers/scheduled';
const WEBHOOK_PATH_NAME = 'triggers/event';
const DATASET_PATH_NAME = 'triggers/scheduled';
const WEBHOOK_SEARCH = `?initialPanelStep=${WEBHOOK_SELECTION}`;
const DATASET_SEARCH = `?isDataset=${DATASET_SELECTION}`;
export const TriggerTypeToRoute = {
  LIST: {
    pathname: LIST_PATH_NAME
  },
  EVENT: {
    pathname: EVENT_PATH_NANE
  },
  SCHEDULED: {
    pathname: SCHEDULED_PATH_NAME
  },
  WEBHOOK: {
    pathname: WEBHOOK_PATH_NAME,
    search: WEBHOOK_SEARCH
  },
  DATASET: {
    pathname: DATASET_PATH_NAME,
    search: DATASET_SEARCH
  }
};